// "Saydalani AI" setting (Paramètres → Saydalani AI, key ai_assistant_enabled). On by default:
// only an explicit false hides the assistant. Also enforced server-side.
export const isAssistantEnabled = (settings) => {
    const value = settings?.ai_assistant_enabled;
    return !(value === false || value === 'false');
};
